import React from 'react'

import Button from '../button'

import { ReactComponent as CloseIcon } from '../../assets/close.svg'

import { StyledErrorWindow, StyledErrorContainer, StyledIconContainer } from './styles'

import {
  Heading3,
  Paragraph,
} from '../../pages/main.style'

import { useTranslation } from 'react-i18next'

const ErrorContainer = ({ label, isFullScreen, children, handleClick }) => {
  const { t } = useTranslation()

  return (
    <StyledErrorWindow isFullScreen={isFullScreen}>
      <StyledErrorContainer>
        <StyledIconContainer>
          {!isFullScreen && <CloseIcon onClick={handleClick} />}
        </StyledIconContainer>
        <Heading3>
          {t('epc_error_message_header')}
        </Heading3>
        <Paragraph width="295px">
          {t('epc_error_message_content')}
        </Paragraph>
        <Button
          onClick={handleClick}
          label={label}
          buttonSize="164px"
          marginSize="0"
        />
      </StyledErrorContainer>
    </StyledErrorWindow>
  )
}

export default ErrorContainer
